import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="Find Your Home"
      items={[
        {
          name: 'homes',
          title: 'Available Now',
          keepParams: true,
        },
        {
          name: 'communities',
          title: 'Communities',
          keepParams: true,
        },
        {
          name: 'plans',
          title: 'Floor Plans',
          keepParams: true,
        },
        {
          name: 'build-on-your-land',
          title: 'Build on Your Land',
          keepParams: true,
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuFind.js